import React, {useState, useEffect} from 'react';
import {Header, Titulo} from '../elementos/Header'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import withRouter from './withRouter';
import Api from '../servicios/api'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioVisita from './FormularioVisita'
import favicon from '../imagenes/logoutm.png'
import Cargando from '../elementos/Cargando'

const EditarVisita = (props) => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [visita, setVisita] = useState([]);

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        fetch(Api+"?consultarVisitaDirectaID="+props.params.id)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setVisita(datosRespuesta[0]);
        })
        .catch(console.log)
    }, [props]);

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <HelmetProvider>
                    <div>
                        <Helmet>
                            <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                            <title>Actualizar Visita</title>
                        </Helmet>
                    </div>
                </HelmetProvider>

                <Header>
                        <Titulo>Actualizar Visita</Titulo>
                        <BtnRegresar ruta="/visitas-directas"/>
                </Header>

                <FormularioVisita  visita={visita}/>
            </>
        );
    }
}
 
export default withRouter(EditarVisita);